import { useSettings } from '@/hooks/state/useSettings';
import { useGetApiV1UserUserIdPartner } from '@/open-api/user/user';

/**
 * Whether partner-program promos (download footer note, floating widget) may
 * be shown: not for live partners or users in the cooling-off window, per the
 * partner status the application form uses. Stays false while the status is
 * loading or if it can't be fetched, so partners are never shown the promo.
 */
export const useCanPromotePartnerProgram = (): boolean => {
  const { settings } = useSettings();

  const userId = Number(settings?.user?.id);
  const hasUserId = Number.isInteger(userId);

  const { data: partnerStatus } = useGetApiV1UserUserIdPartner(userId, {
    query: { enabled: hasUserId },
  });

  if (!(hasUserId && partnerStatus)) {
    return false;
  }

  return !partnerStatus.isPartner && partnerStatus.canApply;
};
